<template>
  <div>
    <v-tabs
        color="grey lighten-5"
        slider-color="black"
        show-arrows
        grow
        >
        <v-tab ripple>
            {{newsNavTitle}}
        </v-tab>
        <v-tab ripple>
            {{aboutNavTitle}}
        </v-tab>
        <v-tab ripple>
            {{trainingNavTitle}}
        </v-tab>
        <v-tab ripple>
            {{aducationNavTitle}}
        </v-tab>
        <v-tab ripple>
            {{programNavTitle}}
        </v-tab>
        <v-tab-item>
            <v-card flat>
            <NewsColumn :mainPart="newsText" 
                :smallPart1="kontaktInfo1"
                :smallPart2a="kontaktInfo2a"
                :smallPart2b="kontaktInfo2b"
                :smallPart2c="kontaktInfo2c"
                :smallPart3a="kontaktInfo3a"
                :smallPart3b="kontaktInfo3b"
                :smallPart3c="kontaktInfo3c"
                :smallPart4a="kontaktInfo4a"
                :smallPart4b="kontaktInfo4b"
                :smallPart4c="kontaktInfo4c"/>
            </v-card>
        </v-tab-item>
        <v-tab-item>
            <v-card flat>

            <HomeTwoColumnText 
                :mainPartTitle="mainInfoTitle"
                :mainPartInfo1="mainInfo1"
                :mainPartInfo2="mainInfo2"
                :mainPartInfo3="mainInfo3"
                :mainPartInfo4="mainInfo4"

                :smallPart1="kontaktInfo1"
                :smallPart2a="kontaktInfo2a"
                :smallPart2b="kontaktInfo2b"
                :smallPart2c="kontaktInfo2c"
                :smallPart3a="kontaktInfo3a"
                :smallPart3b="kontaktInfo3b"
                :smallPart3c="kontaktInfo3c"
                :smallPart4a="kontaktInfo4a"
                :smallPart4b="kontaktInfo4b"
                :smallPart4c="kontaktInfo4c"/>

            </v-card>
        </v-tab-item>
        <v-tab-item>
            <v-card flat>
            <TwoColumnText :mainPart="trainingText" 
                :smallPart1="kontaktInfo1"
                :smallPart2a="kontaktInfo2a"
                :smallPart2b="kontaktInfo2b"
                :smallPart2c="kontaktInfo2c"
                :smallPart3a="kontaktInfo3a"
                :smallPart3b="kontaktInfo3b"
                :smallPart3c="kontaktInfo3c"
                :smallPart4a="kontaktInfo4a"
                :smallPart4b="kontaktInfo4b"
                :smallPart4c="kontaktInfo4c"/>
            </v-card>
        </v-tab-item>
        <v-tab-item>
            <v-card flat>
            <TwoColumnText :mainPart="aducationText" 
                :smallPart1="kontaktInfo1"
                :smallPart2a="kontaktInfo2a"
                :smallPart2b="kontaktInfo2b"
                :smallPart2c="kontaktInfo2c"
                :smallPart3a="kontaktInfo3a"
                :smallPart3b="kontaktInfo3b"
                :smallPart3c="kontaktInfo3c"
                :smallPart4a="kontaktInfo4a"
                :smallPart4b="kontaktInfo4b"
                :smallPart4c="kontaktInfo4c"/>
            </v-card>
        </v-tab-item>
        <v-tab-item>
            <v-card flat>
            <TwoColumnText :mainPart="programText" 
                :smallPart1="kontaktInfo1"
                :smallPart2a="kontaktInfo2a"
                :smallPart2b="kontaktInfo2b"
                :smallPart2c="kontaktInfo2c"
                :smallPart3a="kontaktInfo3a"
                :smallPart3b="kontaktInfo3b"
                :smallPart3c="kontaktInfo3c"
                :smallPart4a="kontaktInfo4a"
                :smallPart4b="kontaktInfo4b"
                :smallPart4c="kontaktInfo4c"/>
            </v-card>
        </v-tab-item>  
    </v-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TwoColumnText from './TwoColumnText'
import HomeTwoColumnText from './HomeTwoColumnText'
import NewsColumn from './NewsColumn'

  export default {
    data () {
      return {
        tab: null
      }
    },
    components: {
        TwoColumnText,
        HomeTwoColumnText,
        NewsColumn,
    },
    computed: {
        ...mapState('ContactModule', [ 
                                        'aboutNavTitle',
                                        'trainingNavTitle',
                                        'aducationNavTitle',
                                        'programNavTitle',

                                        'aboutText',
                                        'trainingText', 
                                        'aducationText', 
                                        'programText',

                                        'kontaktInfo1',
                                        'kontaktInfo2a',
                                        'kontaktInfo2b',
                                        'kontaktInfo2c',
                                        'kontaktInfo3a',
                                        'kontaktInfo3b',
                                        'kontaktInfo3c',
                                        'kontaktInfo4a',
                                        'kontaktInfo4b',
                                        'kontaktInfo4c',

                                        'mainInfoTitle',
                                        'mainInfo1',
                                        'mainInfo2',
                                        'mainInfo3',
                                        'mainInfo4',
                                        'newsNavTitle',
                                        'newsText'
                                        ]),
    },
  }
</script>